<template>
  <nav>
    <!-- absolute app -->
    <v-navigation-drawer  
    v-model="drawer"
    width="100%"
    fixed
      bottom
      temporary  permanent  color="white" >
    
      <p class="text-right">
      <v-btn  icon  @click="closemenumainpage">
              <v-icon>mdi-window-close</v-icon>
            </v-btn>
       </p>

       <v-row>
         <v-col cols="6" class="text-left px-6" style="align-self: center;">
          <v-icon size="30" color="#205295" @click="backtomenu()">mdi-chevron-left</v-icon>
          </v-col>
         <v-col cols="6" align="right" class="text-right pr-6" style="align-self: center;">
       <!-- <p class="text-center"> -->
       <!-- <router-link to="/" exact> -->
        <img  src="@/assets/logo.png" alt="" width="40%"  />
      <!-- </router-link>  -->
       <!-- </p> -->
    </v-col>
       </v-row>
       

      <v-list shaped>
       <!-- <v-subheader v-bind:style="{color: '#000000',fontWeight:'600 !important',fontSize:'18px' }">{{this.lg_footer.security_policy}}  </v-subheader> -->
       <!--  v-model="selectedMenu" -->
        <v-list-item-group v-model="selectedMenu"  active-class="deep-purple--text text--accent-4"  color="primary">
          <v-list-item
            link
            @click="onChange('gb')"
          >
            <v-list-item-icon>
               <country-flag country="gb" size="normal" />
              <!-- <v-icon color="#205295" :class="{ 'active-icon': selectedMenu === 0 }">mdi-shield</v-icon> -->
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>ENGLISH</v-list-item-title>
            </v-list-item-content>

              <v-list-item-icon>
              <v-icon color="#205295" :class="{ 'active-icon': selectedMenu === 0 }">mdi-chevron-right</v-icon>
            </v-list-item-icon>
          </v-list-item>

          <v-list-item
            link
            @click="onChange('th')"
           
          >
            <v-list-item-icon>
                 <country-flag country="th" size="normal" />
              <!-- <v-icon color="#205295" :class="{ 'active-icon': selectedMenu === 1 }">mdi-file-check</v-icon> -->
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>ภาษาไทย</v-list-item-title>
            </v-list-item-content>

              <v-list-item-icon>
              <v-icon color="#205295" :class="{ 'active-icon': selectedMenu === 1 }">mdi-chevron-right</v-icon>
            </v-list-item-icon>
          </v-list-item>

        </v-list-item-group>
      </v-list>
      
      <br/>
      
    </v-navigation-drawer>
  </nav>
</template>

<script>
import { feature } from "../../services/constants.js";
import { lg_menu_mainpage } from "../../views/language/lg_menu_mainpage.js";
import { lg_menu_mainpage_bottom } from "../../views/language/lg_menu_mainpage_bottom.js";
import { lg_menu_mainpage_bottom_policy } from "../../views/language/lg_menu_mainpage_bottom_policy.js";
import { lg_footer } from "../../views/language/lg_footer.js";

export default {
  name: "MenuMainpage",
  props: [],
  menus: null,
  menus_bottom: null,
  menu_All:null,
  defaultlanguage: "",
 data() {
    return {
      selectedMenu: -1,
      selectedMenu2:0,
      drawer: true,
       chooselanguage: [
        { name: "en", flag: "gb",full_name:"ENGLISH" },
        { name: "th", flag: "th",full_name:"THAI" },
      ],
    };
  },
  async beforeCreate() {
     window.scrollTo(0,0);

      if(localStorage.getItem(feature.LANGUAGE) == "th"){
      this.defaultlanguage = "THAI";
      }else{
        this.defaultlanguage = "ENGLISH";
      }

    localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_menu_mainpage = lg_menu_mainpage.lg_menu_mainpage_th)
      : (this.lg_menu_mainpage = lg_menu_mainpage.lg_menu_mainpage_en);

        localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_menu_mainpage_bottom = lg_menu_mainpage_bottom.lg_menu_mainpage_bottom_th)
      : (this.lg_menu_mainpage_bottom = lg_menu_mainpage_bottom.lg_menu_mainpage_bottom_en);

          localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_menu_mainpage_bottom_policy = lg_menu_mainpage_bottom_policy.lg_menu_mainpage_bottom_policy_th)
      : (this.lg_menu_mainpage_bottom_policy = lg_menu_mainpage_bottom_policy.lg_menu_mainpage_bottom_policy_en);

        localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_footer = lg_footer.lg_footer_th)
      : (this.lg_footer = lg_footer.lg_footer_en);
  },
  mounted() {
    let role = localStorage.getItem("role");
      this.menus = this.lg_menu_mainpage;
      this.menus_bottom = this.lg_menu_mainpage_bottom;
      this.menu_All = [...this.lg_menu_mainpage,...this.lg_menu_mainpage_bottom];


    //    this.selectedMenu = this.menu_All.findIndex(
    //   (menu) => {
    //     console.log(menu[2]) 
    //     console.log(this.$route.path) 
    //     menu[2] == this.$route.path}
    // );
    // this.selectedMenu = this.menus.findIndex(
    //   (menu) => menu[2] == this.$route.path
    // );
    // this.selectedMenu2 = this.menus_bottom.findIndex(
    //   (menu) => menu[2] == this.$route.path
    // );
  },
 
  methods: {
    onClickMenu(link) {
      this.$router.push(link).catch((err) => {});
     this.$store.state.navMenuMainpageSwitchLanguage = !this.$store.state.navMenuMainpageSwitchLanguage;
    },
 closemenumainpage(){
  this.$store.state.navMenuMainpage = false;
this.$store.state.navMenuMainpageSwitchLanguage = false;
  },
    onChange(lang) {
      // Do something
      // alert(lang.title);
      // this.defaultlanguage = lang;
      localStorage.setItem(feature.LANGUAGE, lang);
       if(localStorage.getItem(feature.LANGUAGE) == "th"){
      this.defaultlanguage = "THAI";
      }else{
        this.defaultlanguage = "ENGLISH";
      }
      // alert(localStorage.getItem(feature.LANGUAGE));
      // console.log("language header : " + localStorage.getItem(feature.LANGUAGE));
      this.$router.go();
    },
    backtomenu(){
      this.$store.state.navMenuMainpageSwitchLanguage = false;
      this.$store.state.navMenuMainpage = true;
      
    },
     onChange(lang) {
      // Do something
      // alert(lang.title);
      // this.defaultlanguage = lang;
      localStorage.setItem(feature.LANGUAGE, lang);
       if(localStorage.getItem(feature.LANGUAGE) == "th"){
      this.defaultlanguage = "ภาษาไทย";
      }else{
        this.defaultlanguage = "ENGLISH";
      }
      // alert(localStorage.getItem(feature.LANGUAGE));
      // console.log("language header : " + localStorage.getItem(feature.LANGUAGE));
      this.$router.go();
    },
  },
 
  watch: {
    $route(to, from) {
      // ชั้นของ Array || menu[2]
      // this.selectedMenu = this.menul.findIndex((menu) => menu[2] == to.path);
      // this.selectedMenu2 = this.menu_bottom.findIndex((menu) => menu[2] == to.path);
    },
  },
  computed: {},
};
</script>

<style scoped>
.bottom-menu {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.v-application .deep-purple--text.text--accent-4 {
    color: #000000 !important;
    /* color: #6200ea !important; */
    caret-color: #6200ea !important;
}
.active-icon {
   color: #000000 !important;
}
</style>
